module.exports = __webpack_public_path__ + "f27b3907ec269d515a618329c1659c0f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VU.svg
// module id = i26V
// module chunks = 0